import Api from "../axios";

export default async function getPolicyList(){
    return await Api.get('/policy_list')
}